import './ManageFirmwaresPage.css';
import React, {useState, useEffect} from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/common/Header/Header";
import { fetchAllFirmware } from "../../redux/actions/firmware.actions";
import { AppDispatch } from "../../redux/store";
import RootState from "../../redux/states/root.state";
import FirmwaresContainer from "./components/FirmwaresContainer";
import UploadFirmwareModal from "./components/UploadFirmwareModal";
import UpdateFirmwareInfoModal from "./components/UpdateFirmwareInfoModal";
import DeleteFirmwareModal from './components/DeleteFirmwareModal';
import FirmwareDetailsModal from './components/FirmwareDetailsModal';
import { ChipIcon } from '../../components/common/Icons/Icons';

const ManageFirmwaresPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.firmware);

  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [firmwareToModify, setFirmwareToModify] = useState(null);

  useEffect(() => {
    dispatch(fetchAllFirmware(searchParams.toString()))
  }, [dispatch,searchParams]);

  return (
    <div className="page lp-page">
      <UpdateFirmwareInfoModal open={editOpen} setOpen={setEditOpen} object={firmwareToModify}/>
      <DeleteFirmwareModal open={deleteOpen} setOpen={setDeleteOpen} object={firmwareToModify}/>
      <UploadFirmwareModal open={uploadOpen} setOpen={setUploadOpen}/>
      <FirmwareDetailsModal open={viewOpen} setOpen={setViewOpen} object={firmwareToModify}/>

      <Header
        header="Manage Firmware"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><ChipIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Firmware</li>
          </ul>
        }
      />
      <main className="lp-main">
        <FirmwaresContainer
          setEditOpen={setEditOpen}
          setDeleteOpen={setDeleteOpen}
          setViewOpen={setViewOpen}
          setUploadOpen={setUploadOpen}
          setFirmwareToModify={setFirmwareToModify}
        />
      </main>
    </div>
  );
};

export default ManageFirmwaresPage;
